<template>
  <div class="moin_message-container">
    <slot />
  </div>
</template>

<script setup lang="ts">

</script>

<style scoped>
.moin_message-container {
  display: grid;
  width: 100%;
  align-self: flex-start;
  justify-self: center;
  margin-bottom: 8px;
}
</style>
